<!DOCTYPE html>
<html lang="tr">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>Frawgraphy — İstanbul Moda Fotoğraf Stüdyosu | Editorial, Kampanya, Video</title>
<meta name="description" data-i18n-meta="doc.desc" content="Frawgraphy, Beyoğlu'nda editorial, kampanya ve lookbook çekimleri üreten bağımsız bir moda fotoğraf stüdyosu. Videografi ve yapay zekâ destekli görsel üretim.">
<meta name="keywords" content="moda fotoğrafçısı, editorial çekim, kampanya çekimi, lookbook, fotoğraf stüdyosu istanbul, videografi, moda videosu">
<meta name="author" content="Frawgraphy Studio">
<meta name="robots" content="index, follow, max-image-preview:large">
<link rel="canonical" href="https://frawgraphy.com/">

<meta property="og:type" content="website">
<meta property="og:site_name" content="Frawgraphy">
<meta property="og:locale" content="tr_TR">
<meta property="og:url" content="https://frawgraphy.com/">
<meta property="og:title" content="Frawgraphy — İstanbul Moda Fotoğraf Stüdyosu">
<meta property="og:description" content="Editorial, kampanya ve lookbook çekimleri üreten bağımsız bir moda fotoğraf stüdyosu. Beyoğlu, İstanbul.">
<meta property="og:image" content="https://frawgraphy.com/assets/img/hero.jpg">
<meta property="og:image:alt" content="Frawgraphy stüdyosunda çekilmiş moda portresi">

<meta name="twitter:card" content="summary_large_image">
<meta name="twitter:title" content="Frawgraphy — İstanbul Moda Fotoğraf Stüdyosu">
<meta name="twitter:description" content="Editorial, kampanya ve lookbook çekimleri üreten bağımsız bir moda fotoğraf stüdyosu.">
<meta name="twitter:image" content="https://frawgraphy.com/assets/img/hero.jpg">

<link rel="icon" href="/favicon.ico" sizes="any">
<link rel="icon" type="image/png" sizes="32x32" href="/assets/img/favicon-32.png">
<link rel="icon" type="image/png" sizes="16x16" href="/assets/img/favicon-16.png">
<link rel="apple-touch-icon" sizes="180x180" href="/assets/img/apple-touch-icon.png">
<link rel="manifest" href="/site.webmanifest">

<meta name="theme-color" content="#060606" media="(prefers-color-scheme: dark)">
<meta name="theme-color" content="#f5f3f0" media="(prefers-color-scheme: light)">

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,700;0,6..96,900;1,6..96,400;1,6..96,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap">
<link rel="stylesheet" href="assets/css/style.css?v=20260920b">
<noscript><style>.reveal{opacity:1;transform:none}.theme-toggle{visibility:visible!important;opacity:1!important}.loader{display:none}</style></noscript>

<script>
  // Tema ve dili boyamadan önce uygula (flash önlenir)
  (function () {
    var d = document.documentElement;
    try {
      var t = localStorage.getItem('frawgraphy-theme');
      if (!t) t = matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
      d.setAttribute('data-theme', t);
      d.setAttribute('data-lang', localStorage.getItem('frawgraphy-lang') || 'tr');
    } catch (e) {
      d.setAttribute('data-theme', 'dark');
      d.setAttribute('data-lang', 'tr');
    }
  })();
</script>

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": "https://frawgraphy.com/#studio",
  "name": "Frawgraphy Studio",
  "description": "Editorial, kampanya ve lookbook çekimleri üreten bağımsız moda fotoğraf stüdyosu.",
  "url": "https://frawgraphy.com/",
  "image": "https://frawgraphy.com/assets/img/hero.jpg",
  "email": "studio@frawgraphy.com",
  "telephone": "+90-553-324-50-31",
  "priceRange": "$$$",
  "foundingDate": "2016",
  "availableLanguage": ["tr", "en"],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Meşrutiyet Caddesi 41",
    "addressLocality": "Beyoğlu",
    "addressRegion": "İstanbul",
    "postalCode": "34430",
    "addressCountry": "TR"
  },
  "geo": { "@type": "GeoCoordinates", "latitude": 41.0304, "longitude": 28.9744 },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
    "opens": "09:00", "closes": "19:00"
  },
  "areaServed": "TR",
  "knowsAbout": ["Moda fotoğrafçılığı","Editorial çekim","Kampanya çekimi","Lookbook","Videografi"],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Stüdyo hizmetleri",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Editorial çekim" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kampanya çekimi" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Lookbook" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Videografi" } }
    ]
  }
}
</script>
</head>
<body data-title-key="doc.title">

<!-- Sayfa yükleyici: spinner → analog objektif → yazı dönüşümü → flaş -->
<div class="loader" data-loader aria-hidden="true">
  <div class="ldr-stack">
    <svg class="ldr" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <circle class="ldr-knurl" cx="60" cy="60" r="49"/>
      <circle class="ldr-ring"  cx="60" cy="60" r="44"/>
      <circle class="ldr-step"  cx="60" cy="60" r="37"/>
      <circle class="ldr-inner" cx="60" cy="60" r="31"/>
      <circle class="ldr-glass" cx="60" cy="60" r="20"/>
      <polygon class="ldr-blades" points="71.3 66.5 60 73 48.7 66.5 48.7 53.5 60 47 71.3 53.5"/>
      <circle class="ldr-glint" cx="53" cy="52" r="4"/>
      <circle class="ldr-dot" cx="60" cy="13.6" r="1.8"/>
    </svg>
    <p class="ldr-text">
      <span class="ldr-phrase" data-ldr-phrase lang="en">framing the motion</span>
      <span class="ldr-brand" data-ldr-brand>Frawgraphy</span>
    </p>
  </div>
  <span class="ldr-flash"></span>
</div>
<script>
  // Yükleyici kendi kendini yönetir: flaş bitince (veya emniyet süresinde) kapanır.
  (function () {
    var doc = document.documentElement;
    var loader = document.querySelector('[data-loader]');
    if (!loader) return;

    var skip = function () { loader.setAttribute('data-skip', ''); };
    var done = function () {
      loader.setAttribute('data-done', '');
      doc.removeAttribute('data-loading');
    };

    // Yalnızca oturumun ilk girişinde. Site içi gezinmede ve geri/ileri
    // hareketlerinde intro tekrar oynamaz; sekme kapanınca sıfırlanır.
    var SEEN = 'frawgraphy-intro';
    try {
      if (sessionStorage.getItem(SEEN)) { skip(); done(); return; }
      sessionStorage.setItem(SEEN, '1');
    } catch (e) { /* private mode: her girişte oynasın */ }

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { skip(); done(); return; }

    // Her girişte rastgele bir slogan; sözcükler dönüşe sırayla yedirilir
    var phrases = [
      'capturing the perfect',
      'framing the motion',
      'chasing the light',
      'composing the still',
      'developing the frame'
    ];
    var phrase = phrases[Math.floor(Math.random() * phrases.length)];

    // Karakter karakter sarmalama: .w girişi, .c slogan→marka geçişini taşır.
    // --ci sözcükler arasında sürekli artar, böylece dalga tüm satırı kat eder.
    var ci = 0;
    var chars = function (text) {
      return text.replace(/\S/g, function (ch) {
        return '<span class="c" style="--ci:' + (ci++) + '">' + ch + '</span>';
      });
    };

    loader.querySelector('[data-ldr-phrase]').innerHTML =
      phrase.split(' ').map(function (w, i) {
        var html = '<span class="w" style="--wi:' + i + '">' + chars(w) + '</span>';
        ci++;                       // boşluk da dalgada sıra tutar
        return html;
      }).join(' ');

    ci = 0;
    var brandEl = loader.querySelector('[data-ldr-brand]');
    brandEl.innerHTML = chars(brandEl.textContent);

    doc.setAttribute('data-loading', '');
    loader.querySelector('.ldr-flash').addEventListener('animationend', done);
    setTimeout(done, 4200);
  })();
</script>

<a class="skip-link" href="#main" data-i18n="skip">İçeriğe geç</a>

<div class="scroll-progress" aria-hidden="true"><span data-progress></span></div>

{{> header }}

{{> menu }}

<main id="main">

{{{ sections }}}</main>

{{> footer }}

{{#if turnstile}}
<script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer></script>
{{/if}}
<script src="assets/js/i18n.js?v=20260920b" defer></script>
<script src="assets/js/main.js?v=20260920b" defer></script>
</body>
</html>
